import Experience from '../Experience.js'
import Island from './Island.js'
import Cloud from './Cloud.js'
import SegmentOne from './SegmentOne.js'
import SegmentTwo from './SegmentTwo.js'
import SegmentThree from './SegmentThree.js'
import SegmentFour from './SegmentFour.js'
import SegmentFive from './SegmentFive.js'
import SegmentSix from './SegmentSix.js'


export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.islandCount = 6;
        // Wait for resources
        this.resources.on('ready', () =>
        {
           
            this.textureBG = this.resources.items.backgroundTexture;            
            this.textureBGS = this.resources.items.backgroundTextureS;
            this.scene.background = this.textureBG;
            this.loadIslands();           
        })
    }

    loadIslands()
    {
        
        this.island1 = new Island(this.resources.items.islandModel1, this.resources.items.islandTexture1,0);
            this.cloud1 = new Cloud(0);
            this.island2 = new Island(this.resources.items.islandModel2, this.resources.items.islandTexture2,1);
            this.cloud2 = new Cloud(1);
            this.island3 = new Island(this.resources.items.islandModel3, this.resources.items.islandTexture3,2);
            this.island4 = new Island(this.resources.items.islandModel4, this.resources.items.islandTexture4,3);
            this.island5 = new Island(this.resources.items.islandModel5, this.resources.items.islandTexture5,4);
            this.island6 = new Island(this.resources.items.islandModel6, this.resources.items.islandTexture6,5);
            this.cloudStart = new Cloud(3);
            this.cloudStart2 = new Cloud(3);
            if(this.experience.screenType == 2)
            {                
                this.cloudStart.model.position.y = 68;
                this.cloudStart.model.position.x = -5;
                this.cloudStart2.model.position.y = 55;
                this.cloudStart2.model.position.x = 5;
            }
            else
            {
                this.cloudStart.model.position.y = 65;
                this.cloudStart.model.position.x = 35;
                this.cloudStart2.model.position.y = 55;
                this.cloudStart2.model.position.x = 65;
                this.cloudStart.model.position.z = 35;
                this.cloudStart2.model.position.z = 35;
            }
    }

    loadSegment()
    {
        //this.scene.background = this.textureBGS;
        switch(this.experience.curIndex)
        {
            case 0:
                this.segmentOne = new SegmentOne();    
            break;
            case 1:
                this.segmentTwo = new SegmentTwo();    
            break;
            case 2:
                this.segmentThree = new SegmentThree();
            break;
            case 3:
                this.segmentFour = new SegmentFour();
            break;
            case 4:
                this.segmentFive = new SegmentFive();
                break;
            case 5:
                this.segmentSix = new SegmentSix();
            break;
        }
    }
    unloadSegment()
    {       
        //this.scene.background = this.textureBG;
        switch(this.experience.curIndex)
        {
            case 0:
                this.scene.remove(this.segmentOne.modelA)
                this.scene.remove(this.segmentOne.modelB)
                this.segmentOne.unload();
                this.segmentOne = null;
                this.loadIslands();
            break;
            case 1:
                this.scene.remove(this.segmentTwo.modelA)
                this.scene.remove(this.segmentTwo.modelB)
                this.segmentTwo.unload();
                this.segmentTwo = null;
                this.loadIslands();
            break;
            case 2:
                this.scene.remove(this.segmentThree.modelA)
                this.scene.remove(this.segmentThree.modelB)
                this.segmentThree.unload();
                this.segmentThree = null;
                this.loadIslands();
            break;
            case 3:
                this.scene.remove(this.segmentFour.modelA)
                this.scene.remove(this.segmentFour.modelB)
                this.segmentFour.unload();
                this.segmentFour = null;
                this.loadIslands();
            break;
            case 4:
                this.scene.remove(this.segmentFive.modelA)
                this.scene.remove(this.segmentFive.modelB)
                this.segmentFive.unload();
                this.segmentFive = null;
                this.loadIslands();
            break;
            case 5:
                this.scene.remove(this.segmentSix.modelA)
                this.scene.remove(this.segmentSix.modelB)
                this.segmentSix.unload();
                this.segmentSix= null;
                this.loadIslands();
            break;
        }
    }

    update()
    {
        if(this.island1)
            this.island1.update();
        if(this.island2)
            this.island2.update();
        if(this.island3)
            this.island3.update();
        if(this.island4)
            this.island4.update();
        if(this.island5)
            this.island5.update();
        if(this.island6)
            this.island6.update();
        if(this.cloud1)
            this.cloud1.update();
        if(this.cloud2)
            this.cloud2.update();
        if(this.cloudStart)
            this.cloudStart.update();
        if(this.cloudStart2)
            this.cloudStart2.update();
        if(this.cloudStart3)
            this.cloudStart2.update();
        if(this.cloudStart4)
            this.cloudStart2.update();
    }

    destroy()
    {
        if(this.city)
        this.scene.remove(this.city.model)
        if(this.sectors)
        this.scene.remove(this.sectors.model)
        if(this.occluders)
        this.scene.remove(this.occluders.model)   
        if(this.cityT)
        this.scene.remove(this.cityT.model)   

        if(this.city)
            this.city.destroy();
        if(this.city)
            this.city = null;  
        this.sector= null;
        this.occluders = null;
        this.resources.unload();
    }

    unloadIslands()
    {       
        if(this.cloud1)
        {
        this.scene.remove(this.cloud1.model)
        this.cloud1 = null;
        }
        if(this.cloud2)
        {
        this.scene.remove(this.cloud2.model)
        this.cloud2 = null;
        }
        if(this.island1)
        {
        this.scene.remove(this.island1.model)   
        this.island1 = null;
        }
        if(this.island2)
        {
        this.scene.remove(this.island2.model)   
        this.island2 = null;
        }
        if(this.island3)
        {
        this.scene.remove(this.island3.model)
        this.island3 = null;
        }
        if(this.island4)
        {
        this.scene.remove(this.island4.model)
        this.island4 = null;
        }
        if(this.island5)
        {
        this.scene.remove(this.island5.model)
        this.island5 = null;
        }
        if(this.island6)
        {
        this.scene.remove(this.island6.model)
        this.island6 = null;
        }
        this.loadSegment();
    }
}